import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { CdkTableModule } from '@angular/cdk/table';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { HeaderComponent } from '../../shared/header.component';
import { GroupsService } from './groups.service';
import { GroupsDataSource } from './groups.datasource';
import { EditGroupComponent } from './edit-group.component';
import { GroupDto } from '@oracychampions/api-interfaces';
import { ConfirmComponent } from '../../shared/confirm.modal';

@Component({
  selector: 'oc-groups',
  standalone: true,
  imports: [CommonModule, RouterModule, CdkTableModule, HeaderComponent],
  template: `
    <div class="container-fluid page">
      <oc-header headerTitle="Classes">
        <button class="btn btn-primary btn-rounded" (click)="addGroup()">Add Class</button>
      </oc-header>
      <cdk-table #table [dataSource]="dataSource!" class="oc-table">
        <ng-container cdkColumnDef="name">
          <cdk-header-cell *cdkHeaderCellDef class="oc-table-header-cell"> Name </cdk-header-cell>
          <cdk-cell *cdkCellDef="let row" class="oc-table-cell">
            {{ row.name }}
          </cdk-cell>
        </ng-container>

        <ng-container cdkColumnDef="year">
          <cdk-header-cell *cdkHeaderCellDef class="oc-table-header-cell"> Year </cdk-header-cell>
          <cdk-cell *cdkCellDef="let row" class="oc-table-cell">
            <ng-container *ngIf="row.year === 0">Reception</ng-container>
            <ng-container *ngIf="row.year > 0">Year {{ row.year }}</ng-container>
          </cdk-cell>
        </ng-container>

        <ng-container cdkColumnDef="createDate">
          <cdk-header-cell *cdkHeaderCellDef class="oc-table-header-cell"> Created </cdk-header-cell>
          <cdk-cell *cdkCellDef="let row" class="oc-table-cell">
            {{ row.createDate | date }}
          </cdk-cell>
        </ng-container>

        <ng-container cdkColumnDef="actions">
          <cdk-header-cell *cdkHeaderCellDef class="oc-table-header-cell"> &nbsp; </cdk-header-cell>
          <cdk-cell *cdkCellDef="let row" class="oc-table-cell">
            <a (click)="editGroup(row)">Edit</a>&nbsp;<a (click)="deleteGroup(row)">Delete</a>&nbsp;<a
              (click)="openGroup(row)"
              >Open</a
            >
          </cdk-cell>
        </ng-container>

        <cdk-header-row *cdkHeaderRowDef="displayedColumns" class="oc-table-header-row"></cdk-header-row>
        <cdk-row *cdkRowDef="let row; columns: displayedColumns" class="oc-table-row"></cdk-row>
      </cdk-table>
    </div>
  `,
  styles: `
    
  `,
})
export class GroupsComponent {
  private groupsService = inject(GroupsService);
  private modalService = inject(NgbModal);
  private toastr = inject(ToastrService);
  private router = inject(Router);

  dataSource: GroupsDataSource | null = null;
  displayedColumns = ['name', 'year', 'createDate', 'actions'];

  constructor() {
    this.dataSource = new GroupsDataSource(this.groupsService);
  }

  addGroup() {
    const modalRef = this.modalService.open(EditGroupComponent, { fullscreen: true });
    modalRef.closed.subscribe(() => {
      this.groupsService.reloadGroups();
    });
  }

  openGroup(group: GroupDto) {
    this.router.navigate(['/group', group.id]);
  }

  editGroup(group: GroupDto) {
    const modalRef = this.modalService.open(EditGroupComponent, { fullscreen: true });
    modalRef.componentInstance.id = group.id;
    modalRef.componentInstance.model = {
      name: group.name,
      year: group.year,
    };
    modalRef.closed.subscribe(() => {
      this.groupsService.reloadGroups();
    });
  }

  deleteGroup(group: GroupDto) {
    const modalRef = this.modalService.open(ConfirmComponent);
    modalRef.closed.subscribe((confirmed) => {
      if (confirmed) {
        this.groupsService.deleteGroup(group.id).subscribe(() => {
          this.toastr.success('Group deleted');
          this.groupsService.reloadGroups();
        });
      }
    });
  }
}
